export const SHARE_QUERY_KEYS = {
  campaignId: 'storeeel_campaign_id',
  groupId: 'storeeel_group_id',
  contentId: 'storeeel_content_id',
  // 連携配信専用。フィード商品の表示スロット（content/group）のIDは抽選のたびに
  // 変わる仮想IDのため、共有先で再現できない。商品ID（merchant_products.id）という
  // 抽選に左右されない安定IDを別キーで持たせ、共有先で同じ商品を先頭に固定する。
  // このキーは feed_folder の content id（storeeel_content_id）とセットでのみ意味を持つ。
  feedProductId: 'storeeel_feed_product_id',
};

export const stripShareParams = (inputUrl) => {
  const url = new URL(inputUrl);
  Object.values(SHARE_QUERY_KEYS).forEach((key) => {
    url.searchParams.delete(key);
  });
  return url;
};

export const getShareParams = (search = window.location.search) => {
  try {
    const params = new URLSearchParams(search);
    const campaignId = params.get(SHARE_QUERY_KEYS.campaignId);
    const groupId = params.get(SHARE_QUERY_KEYS.groupId);
    const contentId = params.get(SHARE_QUERY_KEYS.contentId);
    const feedProductId = params.get(SHARE_QUERY_KEYS.feedProductId);

    // feedProductId は単独では表示位置を特定できない（付随情報）ため、
    // 「共有リンクかどうか」の判定条件は従来の3キーのまま変えない。
    if (!campaignId && !groupId && !contentId) return null;

    return {
      campaignId: campaignId ? String(campaignId) : null,
      groupId: groupId ? String(groupId) : null,
      contentId: contentId ? String(contentId) : null,
      feedProductId: feedProductId ? String(feedProductId) : null,
    };
  } catch {
    return null;
  }
};

export const buildShareUrl = ({ campaignId, groupId, contentId, feedProductId }) => {
  const url = stripShareParams(window.location.href);
  url.searchParams.delete('_storeeel_preview_campaign_id');

  if (campaignId != null && String(campaignId).length > 0) {
    url.searchParams.set(SHARE_QUERY_KEYS.campaignId, String(campaignId));
  }
  if (groupId != null && String(groupId).length > 0) {
    url.searchParams.set(SHARE_QUERY_KEYS.groupId, String(groupId));
  }
  if (contentId != null && String(contentId).length > 0) {
    url.searchParams.set(SHARE_QUERY_KEYS.contentId, String(contentId));
  }
  if (feedProductId != null && String(feedProductId).length > 0) {
    url.searchParams.set(SHARE_QUERY_KEYS.feedProductId, String(feedProductId));
  }

  return url.toString();
};
